import {
  DeleteOutlined,
  MoreOutlined,
  PlusCircleOutlined,
  SafetyOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Form as AntForm, Avatar, Button, Card, Checkbox, Col, Collapse, ConfigProvider, DatePicker, Divider, Flex, Row, Select, Space } from "antd";
import { Input, InputNumber } from "components/form";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { Field, FieldArray, Form, Formik } from 'formik';
import { useCallback } from "react";

import { useTranslation } from "react-i18next";


function EmployeeSalaryAllowance({
  dataSource = {},
  isLoading = false,
  setMarriageStatus = () => { },
  setDataSource = () => { },
  refButton = null,
  onSubmit = () => { }
}) {
  const { t, i18n } = useTranslation();
  const moneyPersonalAndFamilyRender = (values) => {
    let value = get2DecimalPointsWithCommas(
      (values?.antenatalCareAndDeliveryExpense || 0) +
      (values?.disabledPersonorIncompetentPersonSupport * values?.personalAndFamily?.disabledPersonOrIncompetentPersonSupport?.perPerson || 0) +
      (values?.personalAndFamily?.personalAllowance?.max || 0) +
      values?.personalAndFamily?.parentalCareAllowance?.parentalCareAllowanceList?.filter(o => values?.parentalCareAllowanceList?.includes(o.code))?.map(o => o.amount)?.reduce((accumulator, currentValue) => {
        return accumulator + currentValue
      }, 0) +
      // (values?.personalAndFamily?.childAllowance?.childAllowanceList
      //   ? values.personalAndFamily.childAllowance.childAllowanceList
      //     .filter(o => values?.childAllowanceList?.includes(o.id))
      //     .map(o => o.amount)
      //     .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
      //   : 0)
      (
        values?.childAllowanceList ?
          values?.childAllowanceList?.map(o => Number(o?.childAllowancePermitExpense || 0))
            ?.reduce((accumulator, currentValue) => accumulator + currentValue, 0) || 0
          : 0
      )
      , 0)
    return value !== 0 && value != 'NaN' ? value : ''
  }



  const moneyInsurance = ({ annuityInsurancePremium, healthInsurancePremiumForParents,
    healthInsurancePremiumForSpouse,
    personalHealthInsurancePremium }) => {
    let value = get2DecimalPointsWithCommas(
      (annuityInsurancePremium || 0)
      + (healthInsurancePremiumForParents || 0)
      + (healthInsurancePremiumForSpouse || 0)
      + (personalHealthInsurancePremium || 0)
      , 0)
    return value != 0 && value != 'NaN' ? value : ''
  }
  const moneyOther = (
    {
      donateToAPoliticalParty,
      easyEReceipt,
      educationalSupportDonation,
      generalDonations,
      governmentPensionFund,
      governmentPermanentEmployeeRegisteredProvidentFund,
      interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence,
      nationalSavingsFund,
      privateTeacherAidFundContribution,
      retirementMutualFund,
      socialEnterpriseInvestmentFund,
      socialSecurityFundContribution,
      superSavingsFundUnitPurchase,
      thailandEnvironmentalSocialGovernanceFund,
    }
  ) => {
    let value = get2DecimalPointsWithCommas(
      (donateToAPoliticalParty || 0)
      + (easyEReceipt || 0)
      + (educationalSupportDonation || 0)
      + (generalDonations || 0)
      + (governmentPensionFund || 0)
      + (governmentPermanentEmployeeRegisteredProvidentFund || 0)
      + (interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence || 0)
      + (nationalSavingsFund || 0)
      + (privateTeacherAidFundContribution || 0)
      + (retirementMutualFund || 0)
      + (socialEnterpriseInvestmentFund || 0)
      + (socialSecurityFundContribution || 0)
      + (superSavingsFundUnitPurchase || 0)
      + (thailandEnvironmentalSocialGovernanceFund || 0)
      , 0)
    return value != 0 && value != 'NaN' ? value : ''
  }

  const convertLanguage = useCallback(
    (th, en) => {
      return i18n.language == "en" ? en : th
    },
    [i18n.language],
  )
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...dataSource, personalAllowancePermit: true }}
      onSubmit={onSubmit}
      innerRef={refButton}
    >
      {({ values, setFieldValue, }) => (
        // setDataSource({ ...values }),

        <Form >
          <Card title={t('salary.deduction')}
            loading={isLoading}
          >
            <Flex gap={10} vertical={true}>
              <Collapse expandIconPosition={'end'}>
                <Collapse.Panel extra={values?.personalAndFamily?.personalAllowance?.max
                  && <h2>{moneyPersonalAndFamilyRender(values)}</h2>
                } header={<Space size={20}>
                  <Avatar>
                    <UserOutlined />
                  </Avatar>
                  <Space direction="vertical">
                    <span>{t('allowances.personalAndFamily')}</span>
                  </Space>
                </Space>}>
                  <Flex gap={5} vertical={true}>
                    <Flex style={{ marginLeft: "10px" }} justify="space-between">
                      <AntForm.Item
                        style={{ alignItems: "center", margin: 0 }}
                        colon={false}
                        label={
                          <Flex gap={20} >
                            <Checkbox disabled checked={values.personalAllowancePermit} >
                            </Checkbox>
                            {t('allowances.label.personalAllowance')}
                          </Flex>
                        }
                        tooltip={convertLanguage(values?.personalAndFamily?.personalAllowance?.description, values?.personalAndFamily?.personalAllowance?.descriptionEn)}
                      />
                      {values.personalAllowancePermit &&
                        <><InputNumber
                          readOnly={true}
                          variant="borderless"
                          name="personalAndFamily.personalAllowance.max"
                          placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.personalAndFamily?.personalAllowance?.max ?? 0, 0)}
                          size="large"
                          parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                          formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          max={values?.personalAndFamily?.personalAllowance?.max}
                          controls={false} />
                        </>
                      }
                    </Flex>
                    {values.personalAllowancePermit &&
                      <Flex style={{ marginLeft: "25px" }} justify="space-between">
                        <AntForm.Item
                          style={{ alignItems: "center", margin: 0 }}
                          colon={false}
                          label={
                            <Flex gap={20} >
                              {t('allowances.label.marriageStatus')}
                            </Flex>
                          }>
                        </AntForm.Item>
                        <Select value={values?.personalAndFamily?.personalAllowance?.code} popupMatchSelectWidth={false} size="large"
                          options={values?.personalAndFamily?.marriageStatus}
                          onChange={(e) => {
                            setMarriageStatus(e)
                            setDataSource({ ...values })
                          }}
                        >
                        </Select>
                      </Flex>
                    }
                    <Divider style={{
                      borderBlockStart: '1px solid #d9d9d9',
                      margin: 5
                    }} />
                    <Flex style={{ marginLeft: "10px" }} justify="space-between">
                      <AntForm.Item
                        style={{ alignItems: "center", margin: 0 }}
                        colon={false}
                        label={
                          <Flex gap={20} >
                            <Checkbox checked={values.childAllowancePermit} onChange={(e) => {
                              if (!e?.target?.checked) {
                                setFieldValue('childAllowanceList', [])
                              } else {
                                setFieldValue('childAllowanceList', [])
                              }
                              setFieldValue('childAllowancePermit', e?.target?.checked);
                            }}
                            // disabled={values?.childAllowanceList == null}  //disabled ไว้รอหลังบ้าน
                            >
                            </Checkbox>
                            {t('allowances.label.antenatalCareAndDeliveryExpense')}

                            {/* {t('allowances.label.childAllowance')} */}
                          </Flex>
                        }
                        tooltip={convertLanguage(values?.personalAndFamily?.childAllowance?.description, values?.personalAndFamily?.childAllowance?.descriptionEn)}
                      />
                    </Flex>
                    {values.childAllowancePermit &&
                      // <Flex gap={20} style={{ marginLeft: "25px" }} justify="start">
                      //   {values?.personalAndFamily?.childAllowance?.childAllowanceList?.map(o => {
                      //     return <Checkbox key={o} checked={values?.childAllowanceList?.includes(o.id)} onChange={(e) => {
                      //       let list = []
                      //       if (values?.childAllowanceList) {
                      //         list = [...values?.childAllowanceList]
                      //       }
                      //       // list.push(o.code)
                      //       if (e.target.checked) {
                      //         list.push(o.id)
                      //       } else {
                      //         list = list.filter(item => item != o.id)
                      //       }
                      //       setFieldValue("childAllowanceList", [...list])
                      //     }}>
                      //       {o.fullName}
                      //     </Checkbox>
                      //   })}
                      // </Flex>
                      <FieldArray name="childAllowanceList">
                        {({ remove, push }) => (
                          <div style={{ marginLeft: "25px" }}>
                            {values?.childAllowanceList?.map((_, index) => (
                              <Flex key={index} style={{ marginBottom: "16px", width: "100%" }} justify='space-between' align='end'>
                                <Flex gap={16} style={{ width: "100%" }}>
                                  <Col span={8}>
                                    <Input
                                      name={`childAllowanceList.${index}.childFullName`}
                                      label={t("employee.label.name")}
                                      size='large'
                                    />
                                  </Col>
                                  {/* <Col span={6}>
                                    <Flex vertical>
                                      <span style={{ marginBottom: "8px" }}>{t("employee.date-of-birth")}</span>
                                      <DatePicker name={`childAllowanceList.${index}.childBirthDate`} size='large' placeholder='' />
                                    </Flex>
                                  </Col> */}
                                </Flex>
                                <Flex align='center' gap={8}>
                                  <InputNumber
                                    name={`childAllowanceList.${index}.childAllowancePermitExpense`}
                                    placeholder={t('allowances.label.notMoreThan')
                                      // + get2DecimalPointsWithCommas(values?.personalAndFamily?.antenatalCareAndDeliveryExpense?.max ?? 0, 0)
                                    }
                                    size="large"
                                    parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    // max={values?.personalAndFamily?.antenatalCareAndDeliveryExpense?.max}
                                    controls={false}
                                  />
                                  <Col span={2} style={{ alignContent: "center" }}>
                                    <DeleteOutlined
                                      onClick={() => remove(index)}
                                    />
                                  </Col>
                                </Flex>
                              </Flex>
                            ))}
                            <Flex vertical align="flex-start" >
                              <ConfigProvider wave={{ disabled: true }}>
                                <Button
                                  style={{
                                    color: (values?.childAllowanceList || []).length >= 4 ? null : "var(--button-color)",
                                    backgroundColor: (values?.childAllowanceList || []).length >= 4 ? null : "transparent",
                                    border: "transparent",
                                    boxShadow: "none"
                                  }}
                                  onClick={() => push({})}
                                  disabled={(values?.childAllowanceList || []).length >= 4}
                                >
                                  <PlusCircleOutlined />
                                  <span>{t("allowances.label.addChild")}</span>
                                </Button>
                              </ConfigProvider>
                            </Flex>
                          </div>
                        )}
                      </FieldArray>
                    }
                    <Divider style={{
                      borderBlockStart: '1px solid #d9d9d9',
                      margin: 5
                    }} />
                    <Flex style={{ marginLeft: "10px" }} justify="space-between">
                      <AntForm.Item
                        style={{ alignItems: "center", margin: 0 }}
                        colon={false}
                        label={
                          <Flex gap={20} >
                            <Checkbox checked={values.parentalCareAllowancePermit} onChange={(e) => {
                              if (!e?.target?.checked) {
                                setFieldValue('parentalCareAllowanceList', [])
                              } else {
                                setFieldValue('parentalCareAllowanceList', [])
                              }
                              setFieldValue('parentalCareAllowancePermit', e?.target?.checked);
                            }}>
                            </Checkbox>
                            {t('allowances.label.childAllowance')}
                          </Flex>
                        }
                        tooltip={convertLanguage(values?.personalAndFamily?.parentalCareAllowance?.description, values?.personalAndFamily?.parentalCareAllowance?.descriptionEn)}
                      />
                    </Flex>
                    {values.parentalCareAllowancePermit &&
                      <Flex gap={20} style={{ marginLeft: "25px" }} justify="start">
                        {values?.personalAndFamily?.parentalCareAllowance?.parentalCareAllowanceList?.map(o => {
                          return <Checkbox key={o} checked={values?.parentalCareAllowanceList?.includes(o.code)} onChange={(e) => {
                            let list = []
                            if (values?.parentalCareAllowanceList) {
                              list = [...values?.parentalCareAllowanceList]
                            }
                            // list.push(o.code)
                            if (e.target.checked) {
                              list.push(o.code)
                            } else {
                              list = list.filter(item => item != o.code)
                            }
                            setFieldValue("parentalCareAllowanceList", [...list])
                          }}>
                            {o.name}
                          </Checkbox>
                        })}
                      </Flex>
                    }
                    <Divider style={{
                      borderBlockStart: '1px solid #d9d9d9',
                      margin: 5
                    }} />
                    <Flex style={{ marginLeft: "10px" }} justify="space-between">
                      <AntForm.Item
                        style={{ alignItems: "center", margin: 0 }}
                        colon={false}
                        label={
                          <Flex gap={20} >
                            <Checkbox checked={values.antenatalCareandDeliveryExpensePermit} onChange={(e) => {
                              if (!e?.target?.checked) {
                                setFieldValue('antenatalCareAndDeliveryExpense', 0)
                              } else {
                                setFieldValue('antenatalCareAndDeliveryExpense', null)
                              }
                              setFieldValue('antenatalCareandDeliveryExpensePermit', e?.target?.checked);
                            }}>
                            </Checkbox>
                            {t('allowances.label.parentalCareAllowance')}
                          </Flex>
                        }
                        tooltip={convertLanguage(values?.personalAndFamily?.antenatalCareAndDeliveryExpense?.description, values?.personalAndFamily?.antenatalCareAndDeliveryExpense?.descriptionEn)}
                      />
                      {values.antenatalCareandDeliveryExpensePermit &&
                        <InputNumber
                          name="antenatalCareAndDeliveryExpense"
                          placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.personalAndFamily?.antenatalCareAndDeliveryExpense?.max ?? 0, 0)}
                          size="large"
                          parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                          formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          max={values?.personalAndFamily?.antenatalCareAndDeliveryExpense?.max}
                          controls={false}
                        // onChange={(e) => {
                        //   console.log("e", e);
                        // }}
                        />}
                    </Flex>
                    <Divider style={{
                      borderBlockStart: '1px solid #d9d9d9',
                      margin: 5
                    }} />
                    <Flex style={{ marginLeft: "10px" }} justify="space-between">
                      <AntForm.Item
                        style={{ alignItems: "center", margin: 0 }}
                        // name="email"
                        colon={false}
                        label={
                          <Flex gap={20} >
                            <Checkbox checked={values.disabledPersonorIncompetentPersonSupportPermit} onChange={(e) => {
                              if (!e?.target?.checked) {
                                setFieldValue('disabledPersonorIncompetentPersonSupport', 0)
                              } else {
                                setFieldValue('disabledPersonorIncompetentPersonSupport', null)
                              }
                              setFieldValue('disabledPersonorIncompetentPersonSupportPermit', e?.target?.checked);
                            }}>
                            </Checkbox>
                            {t('allowances.label.disabledPersonIncompetentPersonSupport')}
                          </Flex>
                        }
                        tooltip={convertLanguage(values?.personalAndFamily?.disabledPersonOrIncompetentPersonSupport?.description, values?.personalAndFamily?.disabledPersonOrIncompetentPersonSupport?.descriptionEn)}
                      />
                      {values.disabledPersonorIncompetentPersonSupportPermit &&
                        <InputNumber
                          name="disabledPersonorIncompetentPersonSupport"
                          placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.personalAndFamily?.disabledPersonOrIncompetentPersonSupport?.maxPerson ?? 0, 0)}
                          size="large"
                          parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                          formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          max={values?.personalAndFamily?.disabledPersonOrIncompetentPersonSupport?.maxPerson}
                          controls={false}
                          onChange={(e) => {
                            console.log("e", e);
                          }}
                        />}
                    </Flex>
                    <Divider style={{
                      borderBlockStart: '1px solid #d9d9d9',
                      margin: 5
                    }} />
                  </Flex>
                </Collapse.Panel>
              </Collapse>
              <Collapse expandIconPosition={'end'}>
                <Collapse.Panel extra={<h2>{moneyInsurance(values)}</h2>} header={<Space size={20}>
                  <Avatar>
                    <SafetyOutlined />
                  </Avatar>
                  <span>{t('allowances.insurance')}</span>
                </Space>}>
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.annuityInsurancePremiumPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('annuityInsurancePremium', 0)
                            } else {
                              setFieldValue('annuityInsurancePremium', null)
                            }
                            setFieldValue('annuityInsurancePremiumPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.annuityInsurancePremium')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.insurance?.annuityInsurancePremium?.description, values?.insurance?.annuityInsurancePremium?.descriptionEn)}
                    />
                    {values.annuityInsurancePremiumPermit &&
                      <InputNumber
                        name="annuityInsurancePremium"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.insurance?.annuityInsurancePremium?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.insurance?.annuityInsurancePremium?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.healthInsurancePremiumForParentsPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('healthInsurancePremiumForParents', 0)
                            } else {
                              setFieldValue('healthInsurancePremiumForParents', null)
                            }
                            setFieldValue('healthInsurancePremiumForParentsPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.healthInsurancePremiumForParents')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.insurance?.healthInsurancePremiumForParents?.description, values?.insurance?.healthInsurancePremiumForParents?.descriptionEn)}
                    />
                    {values.healthInsurancePremiumForParentsPermit &&
                      <InputNumber
                        name="healthInsurancePremiumForParents"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.insurance?.healthInsurancePremiumForParents?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.insurance?.healthInsurancePremiumForParents?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.healthInsurancePremiumForSpousePermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('healthInsurancePremiumForSpouse', 0)
                            } else {
                              setFieldValue('healthInsurancePremiumForSpouse', null)
                            }
                            setFieldValue('healthInsurancePremiumForSpousePermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.healthInsurancePremiumForSpouse')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.insurance?.healthInsurancePremiumForSpouse?.description, values?.insurance?.healthInsurancePremiumForSpouse?.descriptionEn)}
                    />
                    {values.healthInsurancePremiumForSpousePermit &&
                      <InputNumber
                        name="healthInsurancePremiumForSpouse"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.insurance?.healthInsurancePremiumForSpouse?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.insurance?.healthInsurancePremiumForSpouse?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.personalHealthInsurancePremiumPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('personalHealthInsurancePremium', 0)
                            } else {
                              setFieldValue('personalHealthInsurancePremium', null)
                            }
                            setFieldValue('personalHealthInsurancePremiumPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.personalHealthInsurancePremium')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.insurance?.personalHealthInsurancePremium?.description, values?.insurance?.personalHealthInsurancePremium?.descriptionEn)}
                    />
                    {values.personalHealthInsurancePremiumPermit &&
                      <InputNumber
                        name="personalHealthInsurancePremium"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.insurance?.personalHealthInsurancePremium?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.insurance?.personalHealthInsurancePremium?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                </Collapse.Panel>
              </Collapse>
              <Collapse expandIconPosition={'end'} >
                <Collapse.Panel extra={<h2>{moneyOther(values)}</h2>} header={<Space size={20}>
                  <Avatar>
                    <MoreOutlined />
                  </Avatar>
                  <span>{t('allowances.other')}</span>
                </Space>}>
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.donateToAPoliticalPartyPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('donateToAPoliticalParty', 0)
                            } else {
                              setFieldValue('donateToAPoliticalParty', null)
                            }
                            setFieldValue('donateToAPoliticalPartyPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.donateToAPoliticalParty')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.donateToAPoliticalParty?.description, values?.other?.donateToAPoliticalParty?.descriptionEn)}
                    />
                    {values.donateToAPoliticalPartyPermit &&
                      <InputNumber
                        name="donateToAPoliticalParty"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.donateToAPoliticalParty?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.donateToAPoliticalParty?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.easyEReceiptPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('easyEReceipt', 0)
                            } else {
                              setFieldValue('easyEReceipt', null)
                            }
                            setFieldValue('easyEReceiptPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.easyEReceipt')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.easyEReceipt?.description, values?.other?.easyEReceipt?.descriptionEn)}
                    />
                    {values.easyEReceiptPermit &&
                      <InputNumber
                        name="easyEReceipt"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.easyEReceipt?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.easyEReceipt?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.educationalSupportDonationPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('educationalSupportDonation', 0)
                            } else {
                              setFieldValue('educationalSupportDonation', null)
                            }
                            setFieldValue('educationalSupportDonationPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.educationalSupportDonation')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.educationalSupportDonation?.description, values?.other?.educationalSupportDonation?.descriptionEn)}
                    />
                    {values.educationalSupportDonationPermit &&
                      <InputNumber
                        name="educationalSupportDonation"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.educationalSupportDonation?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.educationalSupportDonation?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.generalDonationsPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('generalDonations', 0)
                            } else {
                              setFieldValue('generalDonations', null)
                            }
                            setFieldValue('generalDonationsPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.generalDonations')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.generalDonations?.description, values?.other?.generalDonations?.descriptionEn)}
                    />
                    {values.generalDonationsPermit &&
                      <InputNumber
                        name="generalDonations"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.generalDonations?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.generalDonations?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.governmentPensionFundPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('governmentPensionFund', 0)
                            } else {
                              setFieldValue('governmentPensionFund', null)
                            }
                            setFieldValue('governmentPensionFundPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.governmentPensionFund')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.governmentPensionFund?.description, values?.other?.governmentPensionFund?.descriptionEn)}
                    />
                    {values.governmentPensionFundPermit &&
                      <InputNumber
                        name="governmentPensionFund"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.governmentPensionFund?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.governmentPensionFund?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.governmentPermanentEmployeeRegisteredProvidentFundPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('governmentPermanentEmployeeRegisteredProvidentFund', 0)
                            } else {
                              setFieldValue('governmentPermanentEmployeeRegisteredProvidentFund', null)
                            }
                            setFieldValue('governmentPermanentEmployeeRegisteredProvidentFundPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.governmentPermanentEmployeeRegisteredProvidentFund')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.governmentPermanentEmployeeRegisteredProvidentFund?.description, values?.other?.governmentPermanentEmployeeRegisteredProvidentFund?.descriptionEn)}
                    />
                    {values.governmentPermanentEmployeeRegisteredProvidentFundPermit &&
                      <InputNumber
                        name="governmentPermanentEmployeeRegisteredProvidentFund"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.governmentPermanentEmployeeRegisteredProvidentFund?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.governmentPermanentEmployeeRegisteredProvidentFund?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidencePermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence', 0)
                            } else {
                              setFieldValue('interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence', null)
                            }
                            setFieldValue('interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidencePermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence?.description, values?.other?.interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence?.descriptionEn)}
                    />
                    {values.interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidencePermit &&
                      <InputNumber
                        name="interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.interestPaidOnMortgageLoanForPurchaseOrConstructionOfResidence?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.nationalSavingsFundPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('nationalSavingsFund', 0)
                            } else {
                              setFieldValue('nationalSavingsFund', null)
                            }
                            setFieldValue('nationalSavingsFundPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.nationalSavingsFund')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.nationalSavingsFund?.description, values?.other?.nationalSavingsFund?.descriptionEn)}
                    />
                    {values.nationalSavingsFundPermit &&
                      <InputNumber
                        name="nationalSavingsFund"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.nationalSavingsFund?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.nationalSavingsFund?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.privateTeacherAidFundContributionPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('privateTeacherAidFundContribution', 0)
                            } else {
                              setFieldValue('privateTeacherAidFundContribution', null)
                            }
                            setFieldValue('privateTeacherAidFundContributionPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.privateTeacherAidFundContribution')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.privateTeacherAidFundContribution?.description, values?.other?.privateTeacherAidFundContribution?.descriptionEn)}
                    />
                    {values.privateTeacherAidFundContributionPermit &&
                      <InputNumber
                        name="privateTeacherAidFundContribution"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.privateTeacherAidFundContribution?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.privateTeacherAidFundContribution?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.retirementMutualFundPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('retirementMutualFund', 0)
                            } else {
                              setFieldValue('retirementMutualFund', null)
                            }
                            setFieldValue('retirementMutualFundPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.retirementMutualFund')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.retirementMutualFund?.description, values?.other?.retirementMutualFund?.descriptionEn)}
                    />
                    {values.retirementMutualFundPermit &&
                      <InputNumber
                        name="retirementMutualFund"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.retirementMutualFund?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.retirementMutualFund?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.socialEnterpriseInvestmentFundPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('socialEnterpriseInvestmentFund', 0)
                            } else {
                              setFieldValue('socialEnterpriseInvestmentFund', null)
                            }
                            setFieldValue('socialEnterpriseInvestmentFundPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.socialEnterpriseInvestmentFund')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.socialEnterpriseInvestmentFund?.description, values?.other?.socialEnterpriseInvestmentFund?.descriptionEn)}
                    />
                    {values.socialEnterpriseInvestmentFundPermit &&
                      <InputNumber
                        name="socialEnterpriseInvestmentFund"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.socialEnterpriseInvestmentFund?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.socialEnterpriseInvestmentFund?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.socialSecurityFundContributionPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('socialSecurityFundContribution', 0)
                            } else {
                              setFieldValue('socialSecurityFundContribution', null)
                            }
                            setFieldValue('socialSecurityFundContributionPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.socialSecurityFundContribution')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.socialSecurityFundContribution?.description, values?.other?.socialSecurityFundContribution?.descriptionEn)}
                    />
                    {values.socialSecurityFundContributionPermit &&
                      <InputNumber
                        name="socialSecurityFundContribution"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.socialSecurityFundContribution?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.socialSecurityFundContribution?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.superSavingsFundUnitPurchasePermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('superSavingsFundUnitPurchase', 0)
                            } else {
                              setFieldValue('superSavingsFundUnitPurchase', null)
                            }
                            setFieldValue('superSavingsFundUnitPurchasePermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.superSavingsFundUnitPurchase')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.superSavingsFundUnitPurchase?.description, values?.other?.superSavingsFundUnitPurchase?.descriptionEn)}
                    />
                    {values.superSavingsFundUnitPurchasePermit &&
                      <InputNumber
                        name="superSavingsFundUnitPurchase"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.superSavingsFundUnitPurchase?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.superSavingsFundUnitPurchase?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                  <Divider style={{
                    borderBlockStart: '1px solid #d9d9d9',
                    margin: 5
                  }} />
                  <Flex style={{ marginLeft: "10px" }} justify="space-between">
                    <AntForm.Item
                      style={{ alignItems: "center", margin: 0 }}
                      // name="email"
                      colon={false}
                      label={
                        <Flex gap={20} >
                          <Checkbox checked={values.thailandEnvironmentalSocialGovernanceFundPermit} onChange={(e) => {
                            if (!e?.target?.checked) {
                              setFieldValue('thailandEnvironmentalSocialGovernanceFund', 0)
                            } else {
                              setFieldValue('thailandEnvironmentalSocialGovernanceFund', null)
                            }
                            setFieldValue('thailandEnvironmentalSocialGovernanceFundPermit', e?.target?.checked);
                          }}>
                          </Checkbox>
                          {t('allowances.label.thailandEnvironmentalSocialGovernanceFund')}
                        </Flex>
                      }
                      tooltip={convertLanguage(values?.other?.thailandEnvironmentalSocialGovernanceFund?.description, values?.other?.thailandEnvironmentalSocialGovernanceFund?.descriptionEn)}
                    />
                    {values.thailandEnvironmentalSocialGovernanceFundPermit &&
                      <InputNumber
                        name="thailandEnvironmentalSocialGovernanceFund"
                        placeholder={t('allowances.label.notMoreThan') + get2DecimalPointsWithCommas(values?.other?.thailandEnvironmentalSocialGovernanceFund?.max ?? 0, 0)}
                        size="large"
                        parser={value => value.replace(/\฿\s?|(,*)/g, '')}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        max={values?.other?.thailandEnvironmentalSocialGovernanceFund?.max}
                        controls={false}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                      />}
                  </Flex>
                </Collapse.Panel>
              </Collapse>
            </Flex>
          </Card>
        </Form>
      )
      }
    </Formik >
  );
}

export default EmployeeSalaryAllowance;
